module.exports = __webpack_public_path__ + "static/GorditaRegular-d9503c9595cada887ae898ea69534259.otf";